(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExpensesController', PhysicalFairExpensesController);
    PhysicalFairExpensesController.$inject = ['ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];
    function PhysicalFairExpensesController(ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;
        
        vm.flag                  = false;
        vm.expoSelected          = [];
        vm.cities                = [];
        vm.expenses;
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        vm.remove                = remove;

        activate();

        function activate() {
            vm.selectExpo();
            vm.getByFilter();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.citySelected = [];
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.citySelected !== 'undefined') {
                vm.query['expo_location_id'] = vm.citySelected.expos_locations_id;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            PhysicalFairService.getByFilterExpenses(vm.query).then(function(response){
                vm.expenses = response.data.data;
                vm.flag = true;
                if(vm.expenses.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }

                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function remove(city) {            
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this expense?')
                .set('onok', function (){                    
                    PhysicalFairService.destroyExpense(city.expense_id).then(function() {                        
                        angular.forEach(vm.expenses, function (e) {                            
                            if (e['cities'].indexOf(city) != -1)
                                e['cities'].splice(e['cities'].indexOf(city), 1);

                            // If no cities, remove the expo from the list
                            if (e['cities'].length == 0)
                                delete vm.expenses[e.expo_id];
                        });

                        alertify.notify('Expense removed', 'success', 3);
                    });
                })
                .show();
        }
                
    }
})();